import { Badge } from "design-system/badge";

// Turnkey attribution shown on wallet-creation step headers.
export function SecuredByTurnkeyBadge() {
  return (
    <Badge variant="step">
      <img alt="Secured by Turnkey" className="h-4 w-auto" src="/logos/secured-by-turnkey.svg" />
    </Badge>
  );
}
